import _objectSpread from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import IMaskMixin from './mixin.js';
import 'prop-types';
import 'imask/esm/imask';
var IMaskInputClass = IMaskMixin(function (_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, ["inputRef"]);

  return React.createElement('input', _objectSpread({}, props, {
    ref: inputRef
  }));
});

var IMaskInputFn = function IMaskInputFn(props, ref) {
  return React.createElement(IMaskInputClass, _objectSpread({}, props, {
    ref: ref
  }));
} // TODO fix no idea
;

var IMaskInput = React.forwardRef(IMaskInputFn);
export { IMaskInput as default };